import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from "@/views/Dashboard.vue";
import Start from "@/views/Start.vue";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			name: 'start',
			component: Start
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: Dashboard
		},
		{
			path: '/calendar/:id',
			name: 'calendar',
			component: () => import(/* webpackChunkName: "calendar" */ './views/CalendarView.vue')
		},
		{
			path: '/reservations/:id',
			name: 'reservations',
			component: () => import(/* webpackChunkName: "reservations" */ './views/Reservations.vue')
		},
		{
			path: '/settings/:id',
			name: 'settings',
			component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue')
		},
		{
			path: '/embed/:id',
			name: 'embed',
			component: () => import(/* webpackChunkName: "embed" */ './views/Embed.vue')
		},
		{
			path: '/reservation/:id/edit',
			name: 'reservationEdit',
			component: () => import(/* webpackChunkName: "reservationedit" */ './views/ReservationsEdit.vue'),
		},
		{
			path: '/reservation/:id/messages',
			name: 'reservationMessages',
			component: () => import(/* webpackChunkName: "reservationmessages" */ './views/ReservationsMessages.vue'),
		},
		{
			path: '/admin/account',
			name: 'adminAccount',
			component: () => import(/* webpackChunkName: "adminaccount" */ './views/AdminAccount.vue'),
		},
		{
			path: '/admin/resources',
			name: 'adminResources',
			component: () => import(/* webpackChunkName: "adminresources" */ './views/AdminResources.vue'),
		},
		{
			path: '/admin/settings',
			name: 'adminSettings',
			component: () => import(/* webpackChunkName: "adminsettings" */ './views/AdminSettings.vue'),
		},
		{
			path: '/admin/users',
			name: 'adminUsers',
			component: () => import(/* webpackChunkName: "adminusers" */ './views/AdminUsers.vue'),
		},
	],
});
